function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5228 9.57285C11.3812 8.48973 9.92873 7.87743 8.43513 7.734V5.0391L10.3577 6.04443L11.0194 4.90563L9.16948 3.93822L11.0194 2.9708L10.3577 1.832L8.43513 2.83755V1H7.06464V2.83755L5.14207 1.83222L4.48036 2.97102L6.33029 3.93843L4.48036 4.90585L5.14207 6.04465L7.06464 5.0391V7.734C5.57126 7.87743 4.11878 8.48973 2.97716 9.57263C1.70215 10.7821 1 12.3897 1 14.1001C1 15.8105 1.70215 17.4184 2.97716 18.6276C4.29283 19.876 6.02124 20.5 7.74989 20.5C9.47853 20.5 11.2069 19.876 12.5228 18.6276C13.7979 17.4184 14.5 15.8105 14.5 14.1001C14.5 12.3897 13.7979 10.7821 12.5228 9.57285ZM11.5537 17.7082C9.45637 19.6975 6.04386 19.6977 3.94609 17.7082C2.9301 16.7445 2.37049 15.4632 2.37049 14.1001C2.37049 12.7373 2.9301 11.4559 3.94609 10.4922C4.99497 9.49745 6.37232 9.0002 7.74989 9.0002C9.12745 9.0002 10.5048 9.49745 11.5537 10.4924C12.5697 11.4561 13.1293 12.7375 13.1293 14.1003C13.1291 15.4631 12.5697 16.7445 11.5537 17.7082Z",
  fill: "#FB8832",
  stroke: "#FB8832",
  strokeWidth: 0.8
});

function SvgNonGender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonGender);
export default __webpack_public_path__ + "static/media/nonGender.41642668.svg";
export { ForwardRef as ReactComponent };